import ApiHandler from "../libs/ApiHandler";
import Functions from "../utils/functions";
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
import { getGenericAuthModel, removeAuth } from '../utils/sessionStoreAuth';

axios.interceptors.request.use(
  (config) => {
    if (config.headers.common['X-PARTNER-KEY'] == null) {
      let token = getGenericAuthModel('Token')();
      if (token != undefined) {
        config.headers.common['X-PARTNER-KEY'] = token;
      } else {
        pushLoginPage();
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error.response != undefined && error.response.status == 403) {
      pushLoginPage();
    }
    return Promise.reject(error);
  }
);

function pushLoginPage() {
  let route = router.currentRoute;

  if (route.name != 'login' && route.name != 'forgot-password') {  // Prevents duplicated navigation.
    let token = getGenericAuthModel('Token')();
    let error = token != undefined ? 'sessionExpired' : 'credentialsNeeded';
    removeAuth();
    
    let query = {
      nextUrl: route.name,
      error: error,
      ...route.query
    };

    router.push({
      name: 'login',
      params: route.params,
      query: query
    });
  }
}


Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    CommissionCompetence: [],
    TaxInfo: null,

    BankSlipTax: 0,
    CreditCardTax: 0,
    PixTax: 0,
    AnticipationTax: 0,

    BankSlipCommission: 0,
    CreditCardCommission: 0,
    PixCommission: 0,
    AnticipationCommission: 0,

    LinkBankSlipCommission: 0,
    LinkCreditCardCommission: 0,
    LinkPixCommission: 0,
    LinkAnticipationCommission: 0,

    CalcBankSlipCommission: 0,
    CalcCreditCardCommission: 0,
    CalcPixCommission: 0,
  },
  mutations: {
    // Commom
    SET_COMMISSION_COMPETENCE_LIST(state, payload) {
      state.CommissionCompetence = payload;
    },

    // PartnersMerchant
    SET_TAX_INFO(state, payload) {
      state.TaxInfo = payload;
    },
    SET_BANKSLIP_COMMISSION(state, value) {
      state.TaxInfo.BankSlip.Commission = value;
    },
    SET_CREDITCARD_COMMISSION(state, value) {
      state.TaxInfo.CreditCard.Commission = value;
    },
    SET_PIX_COMMISSION(state, value) {
      state.TaxInfo.Pix.Commission = value;
    },

    // PartnersMerchantPreview
    SET_MERCHANTPREVIEW_BANKSLIP_TAX(state, value) {
      state.BankSlipTax = value;
    },
    SET_MERCHANTPREVIEW_CREDITCARD_TAX(state, value) {
      state.CreditCardTax = value;
    },
    SET_MERCHANTPREVIEW_PIX_TAX(state, value) {
      state.PixTax = value;
    },
    SET_MERCHANTPREVIEW_ANTICIPATION_TAX(state, value) {
      state.AnticipationTax = value;
    },
    SET_MERCHANTPREVIEW_BANKSLIP_COMMISSION(state, value) {
      state.BankSlipCommission = value;
    },
    SET_MERCHANTPREVIEW_CREDITCARD_COMMISSION(state, value) {
      state.CreditCardCommission = value;
    },
    SET_MERCHANTPREVIEW_PIX_COMMISSION(state, value) {
      state.PixCommission = value;
    },
    SET_MERCHANTPREVIEW_ANTICIPATION_COMMISSION(state, value) {
      state.AnticipationCommission = value;
    },

    // Links
    SET_LINK_BANKSLIP_COMMISSION(state, value) {
      state.LinkBankSlipCommission = value;
    },
    SET_LINK_CREDITCARD_COMMISSION(state, value) {
      state.LinkCreditCardCommission = value;
    },
    SET_LINK_PIX_COMMISSION(state, value) {
      state.LinkPixCommission = value;
    },
    SET_LINK_ANTICIPATION_COMMISSION(state, value) {
      state.LinkAnticipationCommission = value;
    },

    // Calculator
    SET_CALC_BANKSLIP_COMMISSION(state, value) {
      state.CalcBankSlipCommission = value;
    },
    SET_CALC_CREDITCARD_COMMISSION(state, value) {
      state.CalcCreditCardCommission = value;
    },
    SET_CALC_PIX_COMMISSION(state, value) {
      state.CalcPixCommission = value;
    },
  },
  getters: {
    // Commom
    CommissionCompetence(state) {
      return state.CommissionCompetence;
    },

    // PartnersMerchant
    TaxInfo(state) {
      return state.TaxInfo;
    },

    // PartnersMerchantPreview
    BankSlipTax(state) {
      return state.BankSlipTax;
    },
    CreditCardTax(state) {
      return state.CreditCardTax;
    },
    PixTax(state) {
      return state.PixTax;
    },
    AnticipationTax(state) {
      return state.AnticipationTax;
    },
    BankSlipCommission(state) {
      return state.BankSlipCommission;
    },
    CreditCardCommission(state) {
      return state.CreditCardCommission;
    },
    PixCommission(state) {
      return state.PixCommission;
    },
    AnticipationCommission(state) {
      return state.AnticipationCommission;
    },

    // Links
    LinkBankSlipCommission(state) {
      return state.LinkBankSlipCommission;
    },
    LinkCreditCardCommission(state) {
      return state.LinkCreditCardCommission;
    },
    LinkPixCommission(state) {
      return state.LinkPixCommission;
    },
    LinkAnticipationCommission(state) {
      return state.LinkAnticipationCommission;
    },

    // Calculator
    CalcBankSlipCommission(state) {
      return state.CalcBankSlipCommission;
    },
    CalcCreditCardCommission(state) {
      return state.CalcCreditCardCommission;
    },
    CalcPixCommission(state) {
      return state.CalcPixCommission;
    },
  },
  actions: {
    Authenticate(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.AuthURL(`/AuthenticationPartner/Authenticate`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    CreatePassword(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.AuthURL(`/AuthenticationPartner/CreatePassword`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    LostPassword(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.AuthURL(`/AuthenticationPartner/LostPassword?email=${payload.email}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetProspectNotes(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/ProspectNote/List?IdProspect=${payload.IdProspect}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddProspectNote(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/ProspectNote/Add`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddProspectHistory(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/ProspectHistory/Add`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddPartnerMerchant(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/PartnerMerchant/Add`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    UpdatePartnerMerchant(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/PartnerMerchant/Update`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddPartnerMerchantPreview(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/PartnerMerchantPreview/Add`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddPropectMerchantPreview(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/Prospect/AddMerchantPreview`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListMerchantPreview(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/PartnerMerchantPreview/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantPreviewStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/MerchantPreviewStatus/List`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantPreview(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PartnerMerchantPreview/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateUserPartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/PartnerMerchant/UpdateUserPartner`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListConfigurationTax(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/Util/ConfigurationTax/List`), { params: payload.params })
            .then((response) => {
              if (Functions.hasValue(response.data) && response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    ListPaymentMethod() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/Util/PaymentMethod/List'))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetProspects(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/Prospect/List'), { params: payload.params })
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ReportProspect(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/Prospect/Report'), { params: payload.params })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetProspectProposal(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/ProspectProposal/Get?id=${payload.id}`), payload)
            .then(
              response => {
                resolve(response.data.ResponseDetail);
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetProspectProposalUrl(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/ProspectProposal/GetUrl`), payload)
            .then(
              response => {
                resolve(response.data.ResponseDetail);
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListProspectProposal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/ProspectProposal/List'), { params: payload })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    UpdateProspectUserPartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/Prospect/UpdateUserPartner`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListPartnerMerchant(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/PartnerMerchant/List'), { params: payload.params })
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ReportPartnerMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/PartnerMerchant/Report'), { params: payload.params })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    AddProspect(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/Prospect/Add`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddProspectMerchant(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/Prospect/AddMerchant`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    UpdateProspect(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/Prospect/Update`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    DeleteProspect(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .delete(ApiHandler.URL(`/Prospect/Delete?id=${payload.id}`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    CheckProspect(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/Prospect/Check`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetPartnerMerchant(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/PartnerMerchant/Get?id=${payload.id}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetBankData() {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/PartnerBankData/Get`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    InsertUpdateBankData(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/PartnerBankData/Update`), payload.BankData)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetLink(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/PartnerLink/Get?id=${payload.id}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    UpdateLink(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/PartnerLink/Update`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    DeleteLink(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .delete(ApiHandler.URL(`/PartnerLink/Delete?id=${payload.id}`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetProspect(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/Prospect/Get?id=${payload.id}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetCommissionCompetence() {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/CommissionCompetence/List`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListUser(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/UserPartner/List'), { params: payload.params })
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetUser(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/UserPartner/Get?id=${payload.id}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddUser(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL('/UserPartner/Add'), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    UpdateUser(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/UserPartner/Update`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    UpdateUserProfile(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/UserPartner/UpdateProfile`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ChangePassword(_context, payload) {
      var Token = undefined;
      if (payload.Token != undefined) {
        Token = payload.Token;
        delete payload.Token;
      }
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/UserPartner/ChangePassword?token=${Token}`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    DeleteUser(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .delete(ApiHandler.URL(`/UserPartner/Delete?id=${payload.id}`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListCommissions(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/CheckingAccountPartner/List`), { params: payload.params })
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ReportCommission(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/CheckingAccountPartner/Report'), { params: payload.params })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ReportCommissionVendor(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/CheckingAccountPartner/ReportVendor'), { params: payload.params })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ListLink(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/PartnerLink/List'), { params: payload.params })
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddLink(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL('/PartnerLink/Add'), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetPartner() {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/Partner/Get`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetSignature(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL(`/Util/Signature/Get`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    UpdatePartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .put(ApiHandler.URL(`/Partner/Update`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListNoteExtractPartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/NoteExtractPartner/List'), { params: payload.params })
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ListPartnerMerchantChecklist(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/PartnerMerchant/ListPartnerMerchantChecklist?idMerchant=${payload.id}`), payload)
            .then((response) => {
              if (response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    GetNoteExtractPartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL(`/NoteExtractPartner/Get?id=${payload.id}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    AddNoteExtractPartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL('/NoteExtractPartner/Add'), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    ValidateMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/PartnerMerchant/Validate`), payload)
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DeleteNoteExtractPartner(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .delete(ApiHandler.URL(`/NoteExtractPartner/Delete?id=${payload.id}`), payload)
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        })
    },
    Logoff(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.AuthURL(`/AuthenticationPartner/Logoff?token=${payload.token}`))
            .then(
              response => {
                if (Functions.hasValue(response.data) && response.data.HasError) {
                  reject(response.data);
                } else {
                  resolve(response.data.ResponseDetail);
                }
              },
              error => {
                reject(error);
              }
            );
        });
    },
    GetAddressByCep(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(`https://viacep.com.br/ws/${payload.zipCode}/json/`, {
            transformRequest: (data, headers) => {
              delete headers.common['X-PARTNER-KEY']; // Removing Header
              return data;
            }
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetCities(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Util/City/List?stateInitials=${payload.stateInitials}`))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetStates(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Util/State/List?idCountry=${payload.idCountry}`))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetCountries() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/Util/Country/List'))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ListAccountType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/Util/AccountType/List'))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetBanks() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/Util/Bank/List'))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetPartnerDashboard() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PartnerDashboard/Get`))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ListDocument(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/Document/List'), { params: payload.params })
            .then((response) => {
              if (Functions.hasValue(response.data) && response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    GetDocument(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Document/Get?id=${payload.id}`))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ListUserProfilePartner() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/Util/UserProfilePartner/List'))
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    AddPartnerDoc(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .post(ApiHandler.URL('/PartnerDoc/Add'), payload)
            .then((response) => {
              if (Functions.hasValue(response.data) && response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    GetPartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PartnerDoc/Get?id=${payload.id}`), payload)
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ListPartnerDoc(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/PartnerDoc/List'), { params: payload.params })
            .then((response) => {
              if (Functions.hasValue(response.data) && response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    DeletePartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/PartnerDoc/Delete?id=${payload.id}`), payload)
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ReportPartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/PartnerDoc/Report'), { params: payload.params })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ListPartnerDocType(_context, payload) {
      return new Promise(
        (resolve, reject) => {
          axios
            .get(ApiHandler.URL('/PartnerDocType/List'), { params: payload.params })
            .then((response) => {
              if (response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    ListMerchantMetrics(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/ClientMaintenance/List'), { params: payload.params })
          .then((response) => {
            if (Functions.hasValue(response.data) && response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ReportMerchantMetrics(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL('/ClientMaintenance/Report'), { params: payload.params })
          .then((response) => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js